<template>
  <template v-if="showApply">
    <el-button v-permission="['yop:public:account:add']" class="ml-2" type="primary" size="small" @click="applyAccount(true)">
      申请
    </el-button>
  </template>
  <template v-else-if="info.publicCollectionStatus === EPublicCollectionStatus.PENDING_SUBMIT">
    <el-button v-permission="['yop:public:account:add']" class="ml-2" type="primary" size="small" @click="applyAccount(true)">
      资质申请
    </el-button>
  </template>
  <template v-else-if="info.publicCollectionStatus === EPublicCollectionStatus.PRODUCT_MODIFY_REVIEW_BACK">
    <el-button v-permission="['yop:public:account:add']" class="ml-2" type="primary" size="small" @click="applyAccount(false)">
      重新申请
    </el-button>
  </template>
  <template v-else-if="info.publicCollectionStatus === EPublicCollectionStatus.BANK_OPENING_SMS_AUTH">
    <el-button v-permission="['yop:public:account:add']" class="ml-2" type="primary" size="small" @click="emit('to-verify')">
      短信验证
    </el-button>
  </template>
</template>

<script setup lang="ts">
import { EPublicCollectionStatus, EYibaoAccountStatus, IYibaoBaseInfo } from '@core/main/types';
import { isNull } from '@core/tools';
import { computed, PropType } from 'vue';
import { useRouter } from 'vue-router';

const emit = defineEmits(['to-verify']);

const props = defineProps({
  info: {
    type: Object as PropType<IYibaoBaseInfo>,
    default: () => ({} as IYibaoBaseInfo),
  },
});

const router = useRouter();

const showApply = computed(() => {
  return props.info?.merchantStatus === EYibaoAccountStatus.COMPLETED
    && (isNull(props.info.publicCollectionStatus) || props.info.publicCollectionStatus === EPublicCollectionStatus.DRAFT);
});

function applyAccount(create: boolean) {
  router.push({
    name: 'PublicElectronicApply',
    query: {
      create: create ? 1 : undefined,
      id: props.info.id,
      bank: props.info.publicCollectionOpenbank,
    },
  });
}
</script>
